export default __webpack_public_path__ + "static/media/img_acelera.b3fe1ce8.png";